import { connect } from 'react-redux';
import P3InputElementParentApp from './P3InputElementParentApp';
import { updateDataOfInputElementApp } from '../../../../../../../../../../../redux/workbench/modules/cells.app.module';

export const mapDispatchToProps = {
  updateDataOfInputElementApp,
};

export default connect(null, mapDispatchToProps)(P3InputElementParentApp);
